export default __webpack_public_path__ + "img/ts-back.1d2171e2.jpg";